let _hostname = typeof self !== 'undefined' ? self.location.hostname : '';

const REQUEST_TYPES = {
    REST: 'rest',
    WS: 'WS'
};

const SCHEMAS = {
    HTTP: 'http',
    HTTPS: 'https',
    WS: 'ws',
    WSS: 'wss'
};

const ENVIRONMENTS = {
    LOCAL: 'local',
    TEST: 'test',
    INT: 'int',
    PROD: 'prod'
};

const DEFAULT_CONFIG = {
    subdomain: undefined,
    localdomain: undefined,
    defaultApiPath: {
        REST: '',
        WS: ''
    }
};

function getHostname(){
    return typeof window !== 'undefined' ? window.location.hostname : '';
}

function isLocal(hostname = getHostname()) {
    return hostname === 'localhost' || hostname === '127.0.0.1';
}

function isRegionChina(hostname = getHostname()) {
    return hostname.includes('reachnow.cn');
}

function getEnvironment(hostname = getHostname(), subdomain = 'cockpit') {
    if (isLocal(hostname)) {
        return ENVIRONMENTS.LOCAL;
    }
    
    const domainParts = hostname.split('.');
    if (domainParts[0] === subdomain) {
        const prefix = domainParts[1].split('-').shift().toUpperCase();
        return ENVIRONMENTS[prefix] ? ENVIRONMENTS[prefix] : ENVIRONMENTS.PROD;
    }

    return 'n/a';
}

class EnvironmentService {
    constructor({ subdomain, localdomain, defaultApiPath }) {
        this.subdomain = subdomain;
        this.localdomain = localdomain;
        this.defaultApiPath = defaultApiPath;
    }

    isLocal(hostname = window.location.hostname) {
        return isLocal(hostname);
    }

    getEnvironment(hostname = window.location.hostname) {
        return getEnvironment(hostname, this.subdomain);
    }

    getHost(environment = ENVIRONMENTS.TEST) {
        if (environment === ENVIRONMENTS.LOCAL) {
            return this.localdomain;
        }
        return `${this.subdomain}.${environment}.odm.bmw-fleet.net`;
    }

    getDefaultPath(type = REQUEST_TYPES.REST) {
        return type === REQUEST_TYPES.REST ? this.defaultApiPath.REST : this.defaultApiPath.WS;
    }

    getUrl(type = REQUEST_TYPES.REST, secure = true, environment = ENVIRONMENTS.TEST) {
        let schema = secure ? SCHEMAS.HTTPS : SCHEMAS.HTTP;
        if (type === REQUEST_TYPES.WS) {
            schema = secure ? SCHEMAS.WSS : SCHEMAS.WS;
        }
        return schema + '://' + this.getHost(environment) + this.getDefaultPath(type);
    }

    getRestUrl() {
        return this.getUrl(REQUEST_TYPES.REST, !isLocal(), getEnvironment());
    }

    getWsUrl() {
        return this.getUrl(REQUEST_TYPES.WS, !isLocal(), getEnvironment());
    }
}

export default {
    create(config = DEFAULT_CONFIG) {
        return new EnvironmentService(config);
    },
    // for usage in commons
    getEnvironment,
    isLocal,
    isRegionChina,
    // Just for testing!
    __setHostname(name) {
        _hostname = name;
    },
    __getEnvironment() {
        return getEnvironment(_hostname);
    }
};
